import { css } from '@emotion/react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { useRef } from 'react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { NumberInCircleComponent } from '~/_shared/baseComponents/numberInShape/numberInCircle.component';
import { type ActiveBoundaryFillInfoEntities } from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useGetBoundaryFillEntities';
import { BoundaryKeyHeaderInfoComponent } from '~/sidebar/sidebarApps/rightSidebar/masterKey/boundaryKey/BoundaryKeyHeaderInfo.component';

type ActiveBoundaryDropdownTrigger = Readonly<{
  backgroundColor: string;
  entities: ActiveBoundaryFillInfoEntities;
  fillOrderNumber: number | null;
  foregroundColor: string;
  onClick?: () => void;
}>;

const ddTriggerStyles = css({
  paddingBlock: 4,
  paddingInline: 12,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  userSelect: 'none',
  minHeight: 32,
});

const chevronStyle = css({
  marginLeft: 'auto',
});

const numberInCircleStyles = css({
  fontSize: 14,
});

export const ActiveBoundaryDropdownTriggerComponent = ({
  onClick,
  entities,
  fillOrderNumber,
  foregroundColor,
  backgroundColor,
}: ActiveBoundaryDropdownTrigger) => {
  const triggerRef = useRef<HTMLDivElement>(null);

  const { shortenedSubEntity, mainEntity } = entities;

  return (
    <div
      ref={triggerRef}
      css={[ddTriggerStyles]}
      onClick={onClick}
    >
      {(fillOrderNumber !== null) && (
        <NumberInCircleComponent
          css={numberInCircleStyles}
          colors={{
            fontColor: foregroundColor,
            fillColor: backgroundColor,
          }}
          size={18}
        >
          {fillOrderNumber}
        </NumberInCircleComponent>
      )}
      <BoundaryKeyHeaderInfoComponent
        mainEntity={mainEntity}
        shortenedSubEntity={shortenedSubEntity}
      />
      {onClick && (
        <FontAwesomeIcon
          css={chevronStyle}
          icon={faChevronDown}
          size="lg"
        />
      )}
    </div>
  );
};
